"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const styles = {
  ul: {
    margin: '0px',
    padding: '0px',
    display: 'inline'
  },
  responsiveChip: {
    height: '18px'
  }
};
const useStyles = (0, _styles.makeStyles)(styles);

const ChipFieldArray = _ref => {
  let {
    record,
    source
  } = _ref;
  const classes = useStyles();
  const isXSmall = (0, _useMediaQuery.default)(theme => theme.breakpoints.down('xs'));
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: classes.ul
  }, record && record[source] && record[source].map(item => /*#__PURE__*/_react.default.createElement(_Chip.default, {
    key: item,
    label: item,
    className: isXSmall ? classes.responsiveChip : undefined
  })));
};

ChipFieldArray.propTypes = {
  record: _propTypes.default.object,
  source: _propTypes.default.string
};
ChipFieldArray.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  addLabel: true
};
var _default = ChipFieldArray;
exports.default = _default;